import React from 'react';
import { WidgetProps } from '@wix/yoshi-flow-editor';
import { FormViewerContext } from '@wix/form-viewer/widget';
import { FormActions, FormConfig, FormResults } from '@wix/form-viewer';
import { Widget, ControllerProps } from '../../WixServices/Widget/Widget';
import { FormSection } from './FormSection';
import { PageTitle } from './PageTitle/PageTitle';

export type PageControllerProps = ControllerProps & {
  formId?: string;
  wfActions: FormActions;
  wfConfig: FormConfig;
  wfResults: FormResults;
};

// Page widget wraps the services widget and adds FormSection
const WixServicesPageWidget: React.FC<WidgetProps<PageControllerProps>> = (
  props,
) => {
  const { formId, wfActions, wfConfig, wfResults, ...widgetProps } = props;

  return (
    <FormViewerContext
      host={props.host}
      wfActions={wfActions}
      wfConfig={wfConfig}
      wfResults={wfResults}
    >
      <PageTitle />
      <Widget {...widgetProps} />
      {formId && <FormSection formId={formId} />}
    </FormViewerContext>
  );
};

export default WixServicesPageWidget;
